export { CalloutText } from './CalloutText';
export { PlainText } from './PlainText';
export { PrimaryTitle } from './PrimaryTitle';
export { SectionTitle } from './SectionTitle';
export { SmallText } from './SmallText';
export { TinyText } from './TinyText';

export type { TextProps } from './Text';
